module.exports = __webpack_public_path__ + "img/artwork-6.ddcfa31f.png";